// src/helpers/TranslatedComponent/TranslatedComponent.js

import PropTypes from "prop-types";
import { useT } from "../../hooks/useT";

const Translate = ({ tKey, values = {} }) => {
  const { t } = useT();
  return <>{t(tKey, values)}</>;
};

Translate.propTypes = {
  tKey: PropTypes.string.isRequired,
  values: PropTypes.object,
};

export default Translate;
